// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"6241d388233bed23","273":"1a370d0d2e6f7728","409":"e857288e79fef4a7","514":"c0bc3616dcd6151c","965":"90461f17b51c171b"}[chunkId] + ".js";
};